import styled, { css } from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const AccordionStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  display: flex;
  width: 100%;
  flex-wrap: wrap;

  /* Child element styles
  ------------------------------- */

  /* Modifiers
  ------------------------------- */
  &.filter {
    background-color: ${VARIABLES.COLORS.GRAY_7};
    border: 1px solid ${VARIABLES.COLORS.GRAY_2};
    -webkit-border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
    -moz-border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
    -khtml-border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
    border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
    padding: 8px 14px;

    .accordion-head {
    }

    .accordion-body {
      padding: 0;
      position: relative;
      top: 10px;
      overflow-y: auto;
    }
  }

  &.cart {
    .accordion-head {
      padding: 8px 14px;
    }

    .accordion-body {
      padding: 0;
      position: relative;
    }
  }

  &.accordion-table-data {
    .accordion-head {
      position: relative;

      .table {
        .tbody {
          .table-row {
            .table-column {
              background-color: ${VARIABLES.COLORS.GRAY_7};
            }
          }
        }
      }

      .toggle-icon {
        position: absolute;
        right: 15px;
      }
    }

    .accordion-body {
      padding: 0;
    }
  }

  /* State
  ------------------------------- */
  &.is-open {
    .accordion-head {
      .toggle-icon {
        &:after {
          content: '-';
          /* margin-bottom: 3px; */
        }
      }
    }

    .accordion-body {
      ${props => {
        return css`
          max-height: ${props.bodyHeight + 'px'};
        `
      }}
    }
  }

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
  }

  @media all and (max-width: 1440.98px) {
    &.is-open {
      .accordion-head {
        .toggle-icon {
          &:after {
            margin-bottom: 2px;
          }
        }
      }
    }
  }

  @media all and (max-width: 1366.98px) {
    &.is-open {
      .accordion-head {
        .toggle-icon {
          &:after {
            margin-bottom: 1px;
          }
        }
      }
    }
  }

  @media all and (max-width: 1280.98px) {
    &.is-open {
      .accordion-head {
        .toggle-icon {
          &:after {
            margin-bottom: 0;
          }
        }
      }
    }
  }

  @media all and (max-width: 1024.98px) {
  }
`

export const AccordionHeadStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  display: flex;
  position: relative;
  width: 100%;
  align-items: center;
  cursor: pointer;

  /* Child element styles
  ------------------------------- */
  .toggle-icon {
    width: 14px;
    height: 14px;
    flex: 0 0 14px;
    background-color: transparent;
    border-radius: 50%;
    border: 1px solid ${VARIABLES.COLORS.BLUE_1};
    display: flex;
    align-items: center;
    justify-content: center;

    /* &:after {
      content: '+';
      display: block;
      font-size: 1.25rem;
      color: ${VARIABLES.COLORS.BLUE_1};
      margin-top: -1px;
    } */

    &:after {
      content: '+';
      display: block;
      font-size: 1.25rem;
      color: #4b4acb;
      margin-top: -1px;
      width: 14px;
      height: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  /* Modifiers
  ------------------------------- */
  &.is-only-icon-clickable {
    cursor: initial;
  }

  /* State
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    /* .toggle-icon {
      width: 15px;
      height: 15px;
      flex: 0 0 15px;

      &:after {
        font-size: 19px;
        line-height: 15px;
      }
    } */
  }

  @media all and (max-width: 1440.98px) {
    /* .toggle-icon {
      width: 14px;
      height: 14px;
      flex: 0 0 14px;

      &:after {
        font-size: 18px;
        line-height: 14px;
      }
    } */
  }

  @media all and (max-width: 1366.98px) {
    /* .toggle-icon {
      width: 13px;
      height: 13px;
      flex: 0 0 13px;

      &:after {
        font-size: 17px;
        line-height: 13px;
      }
    } */
  }

  @media all and (max-width: 1280.98px) {
    /* .toggle-icon {
      width: 12px;
      height: 12px;
      flex: 0 0 12px;

      &:after {
        font-size: 16px;
        line-height: 12px;
      }
    } */
  }

  @media all and (max-width: 1024.98px) {
    /* .toggle-icon {
      width: 11px;
      height: 11px;
      flex: 0 0 11px;

      &:after {
        font-size: 14px;
        line-height: 11px;
      }
    } */
  }
`

export const AccordionBodyStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  display: flex;
  width: 100%;
  padding: 0 15px;
  max-height: 0;
  overflow: hidden;
  flex-direction: column;
  transition: all ${VARIABLES.TRANSITIONS.VERY_FAST} ease-in-out;

  /* Child element styles
  ------------------------------- */

  /* Modifiers
  ------------------------------- */

  /* State
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`

export const AccordionContentStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  display: flex;
  flex: 0 0 ${VARIABLES.ELEMENT_SIZES.ACCORDION_SUBMENU_HEIGHT + 'px'};
  width: 100%;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid ${VARIABLES.COLORS.GRAY_4};

  /* Child element styles
  ------------------------------- */

  /* Modifiers
  ------------------------------- */
  &:last-child {
    border-bottom: 0;
  }

  /* State
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`

export const AccordionListStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  display: flex;
  width: 100%;
  flex-direction: column;

  /* Child element styles
  ------------------------------- */

  /* Modifiers
  ------------------------------- */

  /* State
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`
